import { getActionTypesForService } from 'shared/utils/createServiceStore.js';
import { USER_SERVICE_KEY } from './userEnum.js';

export default getActionTypesForService(USER_SERVICE_KEY);
